<div class="login-backdrop" (click)="closePanel()"></div>

<div class="login-panel">
  <span class="panel-close" (click)="closePanel()">✕</span>
  <div class="panel-header">
    <img [src]="branding.logoUrl()" alt="McDonald's" class="panel-logo" />
    <h2>Admin Login</h2>
    <p class="panel-sub">Supporting a massive list of Admin Control Features & whitelist items for Managment and Crew, Reach out for access!!</p>
  </div>

  @if (message) {
    <p class="login-message" [class.success]="messageColor === 'green'" [class.error]="messageColor === 'red'">
      {{ message }}
    </p>
  }
    @if (!authService.isLoggedIn()) {
      <form (ngSubmit)="login()">
        <div class="input-group">
          <input
            type="text"
            [(ngModel)]="username"
            name="username"
            placeholder="Username"
            required
            />
          </div>
          <div class="input-group">
            <input
              type="password"
              [(ngModel)]="password"
              name="password"
              placeholder="Password"
              required
              />
            </div>
            <button type="submit">Login</button>
          </form>
    }@else{
      <button type="button" (click)="logout()">Logout</button>
    }
    </div>
